<template>
	<div class="inline-flex items-center gap-2">
		<!-- Undo button -->
		<button
			type="button"
			data-testid="undo-button"
			class="shrink-0 cursor-pointer disabled:opacity-40 disabled:cursor-default transition"
			:disabled="!canUndo"
			@click="onUndo"
			:title="$t('Undo')"
			tabindex="-1"
		>
			<ArrowUturnLeftIcon class="w-5 h-5" />
		</button>

		<!-- Redo button -->
		<button
			type="button"
			data-testid="redo-button"
			class="shrink-0 cursor-pointer disabled:opacity-40 disabled:cursor-default transition"
			:disabled="!canRedo"
			@click="onRedo"
			:title="$t('Redo')"
			tabindex="-1"
		>
			<ArrowUturnRightIcon class="w-5 h-5" />
		</button>
	</div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { Editor } from "@tiptap/vue-3";
import { ArrowUturnLeftIcon, ArrowUturnRightIcon } from "@heroicons/vue/24/outline";

export default defineComponent({
	name: "UndoRedoComponent",
	components: { ArrowUturnLeftIcon, ArrowUturnRightIcon },
	props: {
		editor: { type: Object as PropType<Editor | null | undefined>, required: true },
	},
	data() {
		return {
			// Bumped on every editor transaction so canUndo/canRedo recompute.
			// The editor's history state is not Vue-reactive on its own.
			historyTick: 0 as number,
			historyUnsub: null as null | (() => void),
		};
	},
	computed: {
		canUndo(): boolean {
			void this.historyTick;
			return this.editor ? !!(this.editor as any).can().undo() : false;
		},
		canRedo(): boolean {
			void this.historyTick;
			return this.editor ? !!(this.editor as any).can().redo() : false;
		},
	},
	methods: {
		onUndo() {
			(this.editor as any)?.chain?.().focus().undo().run();
		},
		onRedo() {
			(this.editor as any)?.chain?.().focus().redo().run();
		},
	},
	mounted() {
		const e = this.editor as any;
		if (!e || typeof e.on !== "function") return;
		const bump = () => {
			this.historyTick++;
		};
		e.on("transaction", bump);
		this.historyUnsub = () => e.off?.("transaction", bump);
	},
	beforeUnmount() {
		this.historyUnsub?.();
		this.historyUnsub = null;
	},
});
</script>
